var map = {
	"./achat/achat.module": [
		"./src/app/pages/achat/achat.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"default~achat-achat-module~laboratoire-laboratoire-module~stats-stats-module~vente-vente-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~stats-stats-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~vente-vente-module",
		"common",
		"achat-achat-module"
	],
	"./admin/admin.module": [
		"./src/app/pages/admin/admin.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~stats-stats-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~vente-vente-module",
		"common",
		"admin-admin-module"
	],
	"./index/index.module": [
		"./src/app/pages/index/index.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"common",
		"index-index-module"
	],
	"./laboratoire/laboratoire.module": [
		"./src/app/pages/laboratoire/laboratoire.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"default~achat-achat-module~laboratoire-laboratoire-module~stats-stats-module~vente-vente-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~stats-stats-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~vente-vente-module",
		"common",
		"laboratoire-laboratoire-module"
	],
	"./stats/stats.module": [
		"./src/app/pages/stats/stats.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"default~achat-achat-module~laboratoire-laboratoire-module~stats-stats-module~vente-vente-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~stats-stats-module",
		"common",
		"stats-stats-module"
	],
	"./vente/vente.module": [
		"./src/app/pages/vente/vente.module.ts",
		"default~achat-achat-module~admin-admin-module~index-index-module~laboratoire-laboratoire-module~stat~687c4a40",
		"default~achat-achat-module~laboratoire-laboratoire-module~stats-stats-module~vente-vente-module",
		"default~achat-achat-module~admin-admin-module~laboratoire-laboratoire-module~vente-vente-module",
		"common",
		"vente-vente-module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		var id = ids[0];
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;